import React from 'react';
import { SimulateurProvider, useSimulateur } from './SimulateurContext';
import { StepIndicator } from './StepIndicator';
import { Step1Transaction } from './steps/Step1Transaction';
import { Step2PropertyType } from './steps/Step2PropertyType';
import { Step3PropertyDetails } from './steps/Step3PropertyDetails';
import { Step4Diagnostics } from './steps/Step4Diagnostics';
import { Step5Contact } from './steps/Step5Contact';
import { Step6Summary } from './steps/Step6Summary';
import { Shield, Clock, Award, Send } from 'lucide-react';

const SimulateurContent = () => {
  const { currentStep, isSubmitted } = useSimulateur();

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1Transaction />;
      case 2:
        return <Step2PropertyType />;
      case 3:
        return <Step3PropertyDetails />;
      case 4:
        return <Step4Diagnostics />;
      case 5:
        return <Step5Contact />;
      case 6:
        return <Step6Summary />;
      default:
        return <Step1Transaction />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-white to-emerald-50">
      {/* Header */}
      <div className="bg-white border-b border-stone-200 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="text-center space-y-2">
            <h1 className="text-3xl md:text-4xl font-bold text-stone-900">
              Obtenez votre devis <span className="text-emerald-600">gratuitement</span>
            </h1>
            <p className="text-stone-600 text-lg">
              Diagnostics immobiliers à Marseille et alentours
            </p>
          </div>
          
          {/* Benefits bar */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-6 text-sm">
            <div className="flex items-center gap-2 text-stone-600">
              <Clock className="w-4 h-4 text-emerald-600" />
              <span>Devis en 2 min</span>
            </div>
            <div className="flex items-center gap-2 text-stone-600">
              <Shield className="w-4 h-4 text-emerald-600" />
              <span>Sans engagement</span>
            </div>
            <div className="flex items-center gap-2 text-stone-600">
              <Award className="w-4 h-4 text-emerald-600" />
              <span>Certifié & assuré</span>
            </div>
            <div className="flex items-center gap-2 text-stone-600">
              <Send className="w-4 h-4 text-emerald-600" />
              <span>Rapport sous 24h</span>
            </div>
          </div>
        </div>
      </div>

      {/* Progress indicator */}
      {!isSubmitted && (
        <div className="max-w-4xl mx-auto px-4">
          <StepIndicator />
        </div>
      )}

      {/* Form content */}
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="bg-white rounded-3xl shadow-xl border border-stone-200 p-6 md:p-10">
          {renderStep()}
        </div>
      </div>

      {/* Footer info */}
      <div className="max-w-4xl mx-auto px-4 pb-12">
        <div className="text-center text-sm text-stone-500">
          <p>
            <strong>Mon Diag Immo</strong> - Anaïs, diagnostiqueuse certifiée
            <br />
            📍 Zone d'intervention : Marseille et 30km autour
            <br />
            📞 06 52 54 79 19 | 📧 mondiagimmo13@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
};

export const Simulateur = () => {
  return (
    <SimulateurProvider>
      <SimulateurContent />
    </SimulateurProvider>
  );
};

export default Simulateur;
